import CustomerScreen from "../../Screen/ERP/Compras/Customers/CustomerScreen";
import CustomerDetailsScreen from "../../Screen/ERP/Compras/Customers/CustomerDetails/CustomerDetailsScreen";
import SalesOrdersScreen from "../../Screen/ERP/Ventas/SalesOrdersScreen";

export const VentasRouter = [
  {
    path: "Ventas/Customers",
    permiso: 34,
    element: <CustomerScreen />,
  },
  {
    path: "Ventas/CustomerDetails",
    permiso: 35,
    element: <CustomerDetailsScreen />,
  },
  {
    path: "Ventas/OrdenesVentas",
    permiso: 106,
    element: <SalesOrdersScreen />,
  },

];

export default VentasRouter;


